import React, { PureComponent } from 'react'
import Input from './Input'
import { FormControl, FormErrorMessage } from '@chakra-ui/react'

export default class FormInput extends PureComponent {
  render() {
    const {
      size,
      isRequired,
      error,
      ref,
      classNameHolder,
      setRef,
      name,
      prefix,
      prefixCls,
      suffix,
      allowClear,
      id,
      type,
      disabled,
      placeholder,
      className,
      maxLength,
      addonBefore,
      addonAfter,
      onPressEnter,
      onKeyDown,
      onKeyUp,
      onBlur,
      onChange,
      onKeyPress,
      value,
      // defaultValue,
    } = this.props

    const fieldProps = {
      size: size ? size : 'large',
      ref: setRef,
      name,
      prefix,
      prefixCls,
      suffix,
      allowClear,
      id,
      type,
      disabled,
      placeholder,
      className,
      maxLength,
      addonBefore,
      addonAfter,
      onPressEnter,
      onKeyDown,
      onKeyUp,
      onBlur,
      onChange,
      onKeyPress,
      // value,
      // defaultValue,
    }

    return (
      <FormControl
        className={classNameHolder}
        isInvalid={error && error.touched && error.error}
        isRequired={isRequired}
      >
        <Input
          variant={error && error.error && error.touched ? 'error' : 'primary'}
          value={value}
          ref={ref}
          {...fieldProps}
        />
        <FormErrorMessage>{error && error.error}</FormErrorMessage>
      </FormControl>
    )
  }
}
